import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import TemplatesPage from '@app/pages/customer/TemplatesList/TemplatesPage.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout';

const RoutesListPage = () => {
  const { t } = useTranslation('common');
  const a = useAuth0();
  return (
    <ResponsiveLayout title={t(`routes.templatesList`, `Seznam šablon`)}>
      {/*
        // @ts-ignore*/}
      <Card>
        <TemplatesPage />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(RoutesListPage);
